import messages from '../../locale/jsonMessages';
import { inputDescLimit, inputTextLimit } from '../../helpers/fieldRestriction';


const validateStep2 = values => {

  const errors = {}
  if (!values?.dynamicListTitleDescription || !values.dynamicListTitleDescription.length) {
    errors.dynamicList = { _error: messages.required };
  } else {
    const documentArrayErrors = [];

    values?.dynamicListTitleDescription?.forEach((document, index) => {
      const documentErrors = {};
      if (!document?.listTitle || document.listTitle.trim() === '') {
        documentErrors.listTitle = messages.required;
      } else if (document?.listTitle?.trim().length > inputTextLimit) {
        documentErrors.listTitle = messages.inputTextLimitError;
      }

      if (!document?.listDescription || document.listDescription.trim() === '') {
        documentErrors.listDescription = messages.required;
      } else if (document?.listDescription?.trim().length > inputDescLimit) {
        documentErrors.listDescription = messages.inputDescLimitError;
      }

      if (!document?.language) {
        documentErrors.language = messages.required;
      }

      if (Object.keys(documentErrors).length > 0) {
        documentArrayErrors[index] = documentErrors;
      }
    });

    if (documentArrayErrors.length) {
      errors.dynamicListTitleDescription = documentArrayErrors;
    }
  }

  return errors
}

export default validateStep2
